import React from 'react';
import { Helmet } from 'react-helmet';
import { getConfig } from 'config.js';

const APP_URL = getConfig('APP_URL');

// Add to CMS
const SITE_NAME = 'Kurt Riddell';
const SITE_DESCRIPTION = 'Director of photography';
const TEXT_SEPERATOR = ' : ';
const IMAGE =
    '//images.contentful.com/kui374n3zzkx/3dhZpgtFAI42EcC6KQkKig/f2a056f8f95d1351103f133fb8353c7a/Screen_Shot_2018-02-01_at_5.31.33_pm.png';

const seoImages = {
    default: `?fm=jpg&w=1280&h=720&fit=thumb&q=90`,
    facebook: `?fm=jpg&w=1200&h=628&fit=thumb&q=90`,
    twitter: `?fm=jpg&w=1024&h=576&fit=thumb&q=90`
};

const seoImageURL = (file, type) => {
    let imageURL = file ? file : IMAGE;
    return imageURL + seoImages[type];
};

const getMetaTags = ({
    title,
    url,
    description,
    image,
    contentType,
    published,
    updated,
    category,
    tags,
    noCrawl
}) => {
    const metaTags = [
        { itemprop: 'name', content: title },
        { itemprop: 'description', content: description },
        { itemprop: 'image', content: seoImageURL(image, 'default') },
        // { name: 'description', content: description },
        { name: 'twitter:card', content: 'summary_large_image' },
        // { name: 'twitter:site', content: SITE_NAME },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        // { name: 'twitter:creator', content: SITE_NAME  },
        // Twitter cards seem to work when the image is http, possibly something to do with same site/domain content?
        {
            name: 'twitter:image:src',
            content: `http:${seoImageURL(image, 'twitter')}`
        },
        { property: 'og:type', content: contentType || 'website' },
        { property: 'og:site_name', content: SITE_NAME },
        { property: 'og:url', content: url },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        {
            property: 'og:image',
            content: `https:${seoImageURL(image, 'default')}`
        }
    ];

    if (noCrawl) {
        metaTags.push({ name: 'robots', content: 'noindex, nofollow' });
    }
    if (published) {
        metaTags.push({ name: 'article:published_time', content: published });
    }
    if (updated) {
        metaTags.push({ name: 'article:modified_time', content: updated });
    }
    if (category) {
        metaTags.push({ name: 'article:section', content: category });
    }
    if (tags) {
        metaTags.push({ name: 'article:tag', content: tags });
    }

    return metaTags;
};

const SEO = ({ schema, title, path, description, ...meta }) => {
    let seoTitle = title ? SITE_NAME + TEXT_SEPERATOR + title : SITE_NAME;
    let seoDescription = description ? description : SITE_DESCRIPTION;
    let seoHref = path ? APP_URL + path : APP_URL;
    let seoType = `http://schema.org/${schema || 'WebPage'}`;

    return (
        <Helmet
            htmlAttributes={{
                lang: 'en',
                itemscope: undefined,
                itemtype: seoType
            }}
            title={seoTitle}
            link={[
                {
                    rel: 'canonical',
                    href: seoHref
                }
            ]}
            meta={getMetaTags({
                title: seoTitle,
                url: seoHref,
                description: seoDescription,
                ...meta
            })}
        />
    );
};

export default SEO;



// WEBPACK FOOTER //
// ./src/utils/seo/index.js